module.exports = __webpack_public_path__ + "static/media/img_rock.daebdcb8.png";